import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from '../../common/breadcrumb';
import {clear_auth, set_auth} from "../../../reducers/Auth";
import {connect} from "react-redux";
import SearchIcon from "../../../assets/icons/search.svg";
import RefreshIcon from "../../../assets/icons/refresh.svg";
import {Checkbox, Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../functions/functionGeneral";
import Paging from "../../paging";
import Add from "./add";
import Edit from "./edit";
import Swal from "sweetalert2";
import FilterIcon from "../../../assets/icons/filter.svg";
import {Table, Tbody, Td, Th, Thead, Tr} from "react-super-responsive-table";
import ArrowUpIcon from "../../../assets/icons/arrow-up.svg";
import ArrowDownIcon from "../../../assets/icons/arrow-down.svg";
import moment from "moment/moment";
import ElipsisIcon from "../../../assets/icons/ellipsis-vertical.svg";
import PlusWhiteIcon from "../../../assets/icons/plus-white.svg";
import CheckIcon from "../../../assets/icons/Check Blue.svg";
import CrossMarkIcon from "../../../assets/icons/cross-mark.svg";
import ConfirmModal from "./confirmation";

class PengajuanInventaris extends Component {
    constructor(props) {
        var namabulan = ("1 2 3 4 5 6 7 8 9 10 11 12");
        namabulan = namabulan.split(" ");
        var tgl = new Date();
        var bulan = tgl.getMonth();
        var tahun = tgl.getFullYear();
        super(props);
        this.state = {
            data: [],
            checked: [],
            karyawan: [],
            inventaris: [],
            month: namabulan[bulan],
            year: tahun,
            currentPage: 0,
        }
    }

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState({
            [name]: value,
        })
    }

    handleFilter = (event) => {
        const { name, value } = event.target;

        this.setState({
            [name]: value,
            currentPage: 0,
        }, () => this.loadData())
    }

    clear = () => {
        this.setState({
            modal_edit          : false,
            modal_add           : false,
            karyawan_selected   : '',
            inventaris_selected : '',
            tanggal_pengajuan   : '',
            pengajuan_desc      : ''
        })
    }

    loadData() {
        this.setState({loading: true})
        let form = {
            filter_nama: this.state.filter_nama,
            filter_month: this.state.month,
            filter_year: this.state.year,
            filter_status: this.state.filter_status,
            paginate: 10,
            page: this.state.currentPage + 1,
        }
        this.props.request("pengajuan_inventaris/list", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data: response.data.data,
                        loading: false,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                    })
                }
            })
    }

    loadDataKaryawan() {
        this.props.request('karyawan/list', 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        karyawan: response.data,
                    })
                }
            })
    }

    loadDataInventaris() {
        this.props.request('inventaris/list', 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        inventaris: response.data.data,
                    })
                }
            })
    }

    handleDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        pengajuan_id: this.state.pengajuan_id
                    }
                    this.props.request("pengajuan_inventaris/delete", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        })
                }
            })
    }

    handlePageClick = (data) => {
        let selected = data.selected
        this.setState({currentPage: selected}, () => {
            this.loadData()
        })
    }

    sortabledate = (val) => {
        const copyArray = this.state.data
        copyArray.sort((a, b) => {
            return val === 0 ? new Date(a.tanggal_pengajuan) - new Date(b.tanggal_pengajuan) : new Date(b.tanggal_pengajuan) - new Date(a.tanggal_pengajuan);
        });
        this.setState({
            data: copyArray
        })
    }

    sortablestatus = (val) => {
        const copyArray = this.state.data
        if (val === 0) {
            copyArray.sort(this.compareBy("pengajuan_status"));
        } else {
            copyArray.reverse();
        }
        this.setState({
            data: copyArray
        })
    }

    compareBy(key) {
        return function (a, b) {
            if (a[key] < (b[key])) return -1;
            if (a[key] > (b[key])) return 1;
            return 0;
        };
    }

    handleCheckBoxChange = (id) => {
        this.setState(prevState => {
            const checked = prevState.checked.includes(id)
                ? prevState.checked.filter(currId => currId !== id)
                : [...prevState.checked, id];
            return {
                checked,
                checkAll: checked.length === prevState.totalData
            }
        })
    }

    handleCheckBoxAllChange = () => {
        this.setState(prevState => {
            const checkAll = !prevState.checkAll;
            return {
                checkAll,
                checked: checkAll ? prevState.data.map(item => item.pengajuan_inv_id) : []
            }
        })
    }

    handleStatus = (status, isBulk = false) => {
        this.setState({loading: true})
        let form = {
            pengajuan_id: isBulk ? this.state.checked : (status === "approved" ? this.state.approveInv : this.state.rejectInv)
        }
        let url = `pengajuan_inventaris/${isBulk ? "bulk/" : ""}${status}`
        this.props.request(url, form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                }
                this.loadData();
                this.setState({confirmModal: null})
            })
    }

    openConfirmModal = (type, isBulk = false) => {
        const titles = {
            approved: "Setujui Pengajuan Inventaris?",
            rejected: "Tolak Pengajuan Inventaris?",
        }
        this.setState({
            confirmModal: {
                type,
                isBulk,
                title: titles[type],
                subtitle: isBulk ? `${this.state.checked.length} Pengajuan terpilih` : null,
                icon: type === "approved" ? CheckIcon : CrossMarkIcon,
                iconBg: type === "approved" ? "#E8F4FF" : "#FFECE8",
                confirmText: type === "approved" ? "Setujui": "Ya",
            },
        })
    }

    componentDidMount() {
        this.loadData()
        this.loadDataKaryawan()
        this.loadDataInventaris()
    }

    render() {
        let no = 0;
        const { confirmModal } = this.state;
        if (!this.props.user.user_level.level_page_limited || this.props.user.user_level.level_page_limited.search("Pengaturan") >= 0) {
            return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>Daftar Pengajuan Inventaris - iPresens</title>
                        <meta name="description" content="Daftar Pengajuan Inventaris"/>
                    </Helmet>
                    <Breadcrumb parent="Pengajuan" title="Daftar Pengajuan Inventaris"/>

                    <Add
                        handleChange={this.handleChange}
                        modal_add={this.state.modal_add}
                        data={this.state}
                        clear={this.clear}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />
                    <Edit
                        handleChange={this.handleChange}
                        modal_edit={this.state.modal_edit}
                        data={this.state}
                        clear={this.clear}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />

                    {confirmModal && (
                        <ConfirmModal
                            isOpen={true}
                            toggle={() => this.setState({confirmModal: null})}
                            title={confirmModal.title}
                            subtitle={confirmModal.subtitle}
                            icon={confirmModal.icon}
                            iconBg={confirmModal.iconBg}
                            onConfirm={() => this.handleStatus(confirmModal.type, confirmModal.isBulk)}
                            confirmText={confirmModal.confirmText}
                        />
                    )}

                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className='col-md-5'>
                                        <div className='d-flex flex-row'>
                                            <div className='flex-fill pr-2 mb-2 mb-md-0'>
                                                <div className='input-group btn-search-k-beban' style={{height: "100%"}}>
                                                    <span className="input-group-text izin-search-karyawan-img" id="basic-addon1">
                                                        <img alt='' src={SearchIcon}/>
                                                    </span>
                                                    <input type="text" name='filter_nama' onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            this.setState({
                                                                data: [],
                                                                page: 0,
                                                                paging: this.state.paging,
                                                                loading: true
                                                            }, () => {
                                                                this.loadData()
                                                            });
                                                        }
                                                    }} value={this.state.filter_nama} onChange={this.handleChange}
                                                           className="form-control izin-search-karyawan-form"
                                                           placeholder="Cari nama karyawan..." aria-label="Username"
                                                           aria-describedby="basic-addon1"/>
                                                </div>
                                            </div>
                                            <div>
                                                <button className='btn primary button-filter width-filter filter-button' onClick={() => this.setState({filter: !this.state.filter})}>
                                                    <img src={FilterIcon}/> Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-7 d-flex justify-content-end flex-wrap'>
                                        {!this.state.loading && (
                                            <>
                                                <div className="d-flex mb-2 izin-btn-w100">
                                                    <button
                                                        className='izin-tolak-button text-capitalize mr-1 w-100'
                                                        style={{borderRadius: "6px", height: "2.4rem"}}
                                                        onClick={() => this.openConfirmModal("rejected", true)}
                                                        disabled={this.state.checked.length === 0}>
                                                        Tolak
                                                    </button>
                                                    <button
                                                        className='btn btn-primary text-capitalize ml-1 mr-md-2 w-100'
                                                        style={{height: "2.4rem"}}
                                                        onClick={() => this.openConfirmModal("approved", true)}
                                                        disabled={this.state.checked.length === 0}>
                                                        Setujui
                                                    </button>
                                                </div>
                                                <button
                                                    className='btn btn-primary text-capitalize izin-btn-w100'
                                                    style={{borderRadius: "6px", height: "2.4rem"}}
                                                    onClick={() => {this.setState({modal_add: true});}}>
                                                    <img src={PlusWhiteIcon} alt=''/> Tambah
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                                {this.state.filter &&
                                    <div className='row mx-0'>
                                        <div className='col-md-2 px-1 mb-2'>
                                            <label className='form-label font-12'>Bulan</label>
                                            <select name="month" className='form-control font-12' value={this.state.month} onChange={this.handleFilter}>
                                                <option value="">Pilih Bulan</option>
                                                <option value="1">Januari</option>
                                                <option value="2">Februari</option>
                                                <option value="3">Maret</option>
                                                <option value="4">April</option>
                                                <option value="5">Mei</option>
                                                <option value="6">Juni</option>
                                                <option value="7">Juli</option>
                                                <option value="8">Agustus</option>
                                                <option value="9">September</option>
                                                <option value="10">Oktober</option>
                                                <option value="11">November</option>
                                                <option value="12">Desember</option>
                                            </select>
                                        </div>
                                        <div className='col-md-2 px-1 mb-2'>
                                            <label className='form-label font-12'>Tahun</label>
                                            <select name="year" className='form-control font-12' value={this.state.year} onChange={this.handleFilter}>
                                                <option value="">Pilih Tahun</option>
                                                <option value="2020">2020</option>
                                                <option value="2021">2021</option>
                                                <option value="2022">2022</option>
                                                <option value="2023">2023</option>
                                                <option value="2024">2024</option>
                                                <option value="2025">2025</option>
                                                <option value="2026">2026</option>
                                            </select>
                                        </div>
                                        <div className='col-auto px-1 d-flex align-items-end justify-content-end mb-2'>
                                            <div className='btn-group width-filter'>
                                                <button
                                                    className={'btn text-capitalize custom-btn-group filter-masuk button-filter-lembur' + (this.state.filter_status === "new" ? ' ipresens-active-custom-btn-group' : '')}
                                                    onClick={() => this.setState({ filter_status: "new" }, () => this.loadData())}>
                                                    Mengunggu
                                                </button>
                                                <button
                                                    className={'btn text-capitalize custom-btn-group filter-masuk button-filter-lembur' + (this.state.filter_status === "approved" ? ' ipresens-active-custom-btn-group' : '')}
                                                    onClick={() => this.setState({ filter_status: "approved" }, () => this.loadData())}>
                                                    Disetujui
                                                </button>
                                                <button
                                                    className={'btn text-capitalize custom-btn-group filter-masuk button-filter-lembur' + (this.state.filter_status === "rejected" ? ' ipresens-active-custom-btn-group' : '')}
                                                    onClick={() => this.setState({ filter_status: "rejected" }, () => this.loadData())}>
                                                    Ditolak
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-auto px-1 d-flex align-items-end justify-content-end pb-2'>
                                            <button className='btn text-capitalize px-2 width-filter btn-reset-filter' onClick={
                                                () => {
                                                    this.setState({
                                                        filter_nama: "",
                                                        month: ("1 2 3 4 5 6 7 8 9 10 11 12").split(" ")[new Date().getMonth()],
                                                        year: new Date().getFullYear(),
                                                        filter_status: "",
                                                    }, () => this.loadData())
                                                }
                                            }><img src={RefreshIcon} alt="icon refresh" /> Reset Filter</button>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            {!this.state.loading && this.state.data.length === 0 ?
                                                <Empty description="Data Kosong"
                                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" />
                                                :
                                                <div>
                                                    <Table className="table table-striped table-borderless mb-5">
                                                        <Thead>
                                                            <Tr align="center">
                                                                <Th><Checkbox checked={this.state.checkAll} onChange={this.handleCheckBoxAllChange}></Checkbox></Th>
                                                                <Th className="izin-th-style">#</Th>
                                                                <Th className="izin-th-style">Nama Karyawan</Th>
                                                                <Th className="izin-th-style">Nama Inventaris</Th>
                                                                <Th className="px-1" width={160}>
                                                                    <div className='d-flex'>
                                                                        <div className='izin-th-style'>Tanggal Pengajuan </div>
                                                                        <div className='ml-1 d-flex flex-column pt-1'>
                                                                            <img alt='' onClick={() => {
                                                                                this.sortabledate(1)
                                                                            }} style={{width: "8px", height: "8px"}}
                                                                                 className='izin-btn'
                                                                                 src={ArrowUpIcon}/>
                                                                            <img alt='' onClick={() => {
                                                                                this.sortabledate(0)
                                                                            }} style={{width: "8px", height: "8px"}}
                                                                                 className='izin-btn'
                                                                                 src={ArrowDownIcon}/>
                                                                        </div>
                                                                    </div>
                                                                </Th>
                                                                <Th className="izin-th-style">Keterangan</Th>
                                                                <Th className="px-1">
                                                                    <div className='d-flex'>
                                                                        <div className='izin-th-style'>Status</div>
                                                                        <div className='ml-1 d-flex flex-column pt-1'>
                                                                            <img alt=''
                                                                                 style={{width: "8px", height: "8px"}}
                                                                                 className='izin-btn' src={ArrowUpIcon}
                                                                                 onClick={() => {
                                                                                     this.sortablestatus(1)
                                                                                 }}/>
                                                                            <img alt=''
                                                                                 style={{width: "8px", height: "8px"}}
                                                                                 className='izin-btn'
                                                                                 src={ArrowDownIcon}
                                                                                 onClick={() => {
                                                                                     this.sortablestatus(0)
                                                                                 }}/>
                                                                        </div>
                                                                    </div>
                                                                </Th>
                                                                <Th className="izin-th-style"></Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            {this.state.loading ?
                                                                <Tr>
                                                                    <Td colSpan={9}>
                                                                        <Spin size="large" tip="Loading..." style={{
                                                                            width: '100%',
                                                                            margin: 'auto',
                                                                            marginBottom: '10px',
                                                                            marginTop: '10px'
                                                                        }}/>
                                                                    </Td>
                                                                </Tr>
                                                                :
                                                                <>
                                                                    {this.state.data.map((item) => {
                                                                        no += 1
                                                                        return (
                                                                            <Tr>
                                                                                <Td><Checkbox checked={this.state.checked.includes(item.pengajuan_inv_id)} onChange={() => this.handleCheckBoxChange(item.pengajuan_inv_id)}></Checkbox></Td>
                                                                                <Td scope="row" className="izin-td-style">{pageNumber(no, this.state.perPage, this.state.currentPage)}</Td>
                                                                                <Td className="izin-td-style">
                                                                                    <a href={"/karyawan/profil/detail/" + item.karyawan.karyawan_slug}>
                                                                                        {item.karyawan.karyawan_nama}
                                                                                    </a>
                                                                                </Td>
                                                                                <Td className="text-capitalize izin-td-style">{item.inventaris.inventaris_name}</Td>
                                                                                <Td className="izin-td-style">{moment(item.tanggal_pengajuan).format('ll')}</Td>
                                                                                <Td className="izin-td-style">{this.state.slice_string ? item.pengajuan_desc.slice(0, 44) : item.pengajuan_desc}{item.pengajuan_desc.length >= 45 && this.state.slice_string === true ?
                                                                                    <button className='izin-btn' style={{
                                                                                        color: "#6BA9FF",
                                                                                        fontSize: "24px",
                                                                                        fontWeight: 400,
                                                                                        padding: "0px"
                                                                                    }} onClick={() => {
                                                                                        this.setState({slice_string: false})
                                                                                    }}>...</button> : ""}
                                                                                    {item.pengajuan_desc.length >= 45 && this.state.slice_string === false ?
                                                                                        <button className='izin-btn' style={{
                                                                                            color: "#6BA9FF",
                                                                                            fontSize: "14px",
                                                                                            fontWeight: 400,
                                                                                            padding: "0px"
                                                                                        }} onClick={() => {
                                                                                            this.setState({slice_string: true})
                                                                                        }}>lebih sedikit</button> : ""}
                                                                                </Td>
                                                                                <Td className="izin-td-style" style={{
                                                                                    color: item.pengajuan_status === "new" || item.pengajuan_status === "draft" ? "#FF9C00" :
                                                                                        item.pengajuan_status === "rejected" ? "#E03616" :
                                                                                            item.pengajuan_status === "approved" ? "#1E7E0E" : ""
                                                                                }}>
                                                                                    {item.pengajuan_status === "new" || item.pengajuan_status === "draft" ? "menunggu" :
                                                                                        item.pengajuan_status === "rejected" ? "Ditolak" :
                                                                                            item.pengajuan_status === "approved" ? "Disetujui" :
                                                                                                ""}
                                                                                </Td>
                                                                                <Td className="izin-td-style">
                                                                                    <Tooltip trigger={'click'} placement="bottom" color={'#fff'} zIndex={1} title={
                                                                                        <div className={'d-flex flex-column'}>
                                                                                            {item.pengajuan_status !== "approved" &&
                                                                                                <button style={{width: "84px"}} className='izin-btn izin-tooltip-menu px-2 py-1 mb-1' onClick={() => {
                                                                                                    this.setState({
                                                                                                        approveInv: item.pengajuan_inv_id,
                                                                                                    },() => this.openConfirmModal("approved"))
                                                                                                }}>Setujui</button>
                                                                                            }
                                                                                            {item.pengajuan_status !== "rejected" &&
                                                                                                <button style={{width: "84px"}} className='izin-btn izin-tooltip-menu px-2 py-1 mb-1' onClick={() => {
                                                                                                    this.setState({
                                                                                                        rejectInv: item.pengajuan_inv_id,
                                                                                                    },() => this.openConfirmModal("rejected"))
                                                                                                }}>Tolak</button>
                                                                                            }
                                                                                            <button style={{width: "84px", color: "#1a37e1"}} className="izin-btn izin-tooltip-menu px-2 py-1 mb-1" onClick={() => {
                                                                                                this.setState({
                                                                                                    modal_edit: true,
                                                                                                    pengajuan_inv_id: item.pengajuan_inv_id,
                                                                                                    karyawan_selected: {
                                                                                                        value: item.karyawan.karyawan_id,
                                                                                                        label: item.karyawan.karyawan_nama
                                                                                                    },
                                                                                                    inventaris_selected: {
                                                                                                        value: item.inventaris.inventaris_id,
                                                                                                        label: item.inventaris.inventaris_name
                                                                                                    },
                                                                                                    tanggal_pengajuan: item.tanggal_pengajuan,
                                                                                                    pengajuan_desc: item.pengajuan_desc,
                                                                                                })}}>Edit
                                                                                            </button>
                                                                                            <button style={{width: "84px", color: "red"}} className='izin-btn izin-tooltip-menu px-2 py-1' onClick={() => {
                                                                                                this.setState({
                                                                                                    pengajuan_id: item.pengajuan_inv_id,
                                                                                                })
                                                                                                this.handleDelete()
                                                                                            }}>Hapus</button>
                                                                                        </div>
                                                                                    }>
                                                                                        <button className='izin-btn'>
                                                                                            <img alt='' src={ElipsisIcon}/>
                                                                                        </button>
                                                                                    </Tooltip>
                                                                                </Td>
                                                                            </Tr>
                                                                        )
                                                                    })}
                                                                </>
                                                            }
                                                        </Tbody>
                                                    </Table>
                                                </div>
                                            }
                                        </div>
                                        <div className="row">
                                            <div className='col font-14 fw-500 m-auto'>
                                                Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} Dari {this.state.totalData} Data.
                                            </div>
                                            <div className="col">
                                                <Paging
                                                    className="float-right"
                                                    handlePageClick={this.handlePageClick}
                                                    pageCount={this.state.pageCount}
                                                    currentPage={this.state.currentPage}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(PengajuanInventaris);
